module.exports = __webpack_public_path__ + "media/images/review/star_2-e4c3a107000784836aa55d6689e6d73c.svg";